
<tilby-dialog-toolbar mat-dialog-title [title]="title" (confirm)="confirm()" [hideConfirm]="!enableConfirm || !selectedReservation">
    <div class="tw-w-fit tw-ml-4 tw-font-bold" toolbar-content>
        @if ( mode === 'payment' ) {
            <span class="tw-font-medium">{{amountToPay}}</span>
        }

        <app-barcode [hideButton]="true" (onSubmitBarcode)="onBarcodeScanned($event)"></app-barcode>
    </div>
</tilby-dialog-toolbar>
@if (isOffline()) {
    <div class="tw-flex tw-justify-center tw-py-4">
        <span translate>CASHREGISTER.LEAN_PMS_PAYMENTS.CHECK_CONNECTION</span>
    </div>
}
@if(message) {
    <div class="tw-flex tw-justify-center tw-py-4" (click)="deleteMessage()">
        <span>{{message | translate}}</span>
    </div>
}
@if ( operationInProgress ) {
    <tilby-dialog-progress-bar/>
}

<tilby-dialog-content class="lean-pms-payments tw-flex tw-flex-col">
    @if ( status != 'login' && status != 'hotel-select' ) {
        <div class="tw-flex tw-flex-col" [ngClass]="isMobile() ? ['tw-justify-around'] : [] ">
            <mat-form-field class="tw-m-0">
                <mat-label>{{'CASHREGISTER.PMS_COMMON.SEARCH' | translate}}</mat-label>
                <input matInput type="search" aria-label="Search" [disabled]="isOffline()"
                    [ngModel]="searchText" (ngModelChange)="onFieldSearchChange($event)" />
            </mat-form-field>

            <mat-tab-group animationDuration="0ms" mat-stretch-tabs (selectedTabChange)="changeReservationType($event)">
                <mat-tab label="{{'CASHREGISTER.LEAN_PMS_PAYMENTS.RESERVATIONS' | translate }}" isActive="status === 'reservations-select'"></mat-tab>
                <mat-tab label="{{'CASHREGISTER.LEAN_PMS_PAYMENTS.GROUPED_RESERVATIONS' | translate }}" isActive="status === 'groupedreservations-select'"></mat-tab>
            </mat-tab-group>
        </div>
    }

    @if ( fetchingReservations ) {
        <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-mt-1 tw-h-[250px]">
            <mat-spinner />
        </div>
    }

    @if ( status != null ) {
        @switch (status) {
            @case ('reservations-select') {
                <div class="tw-flex tw-flex-col tw-mb-4 tw-overflow-auto">
                    @if ( !fetchingReservations && !visibleReservations.length ) {
                        <div class="tw-text-blue-500 tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-[100px]">
                            <span translate>CASHREGISTER.PMS_COMMON.NO_ACCOUNT_AVAILABLE</span>
                        </div>
                    } @else {
                        <mat-selection-list class="tw-overflow-y-auto" [multiple]="false" (selectionChange)="onSelectionChange($event)">
                            @for ( reservation of visibleReservations; track reservation.id) {
                                <mat-list-option [value]="reservation" class="tw-h-fit" [selected]="reservation === selectedReservation">
                                    <div class="tw-flex tw-flex-row tw-w-full">
                                        <mat-icon class="tw-mr-2" matListItemIcon>meeting_room</mat-icon>
                                        <div class="tw-flex tw-flex-row tw-w-full tw-justify-between tw-min-w-0">
                                            <div class="tw-flex tw-flex-col tw-flex-1 tw-min-w-0 tw-overflow-hidden">
                                                @if (reservation?.reference) {
                                                    <div>{{reservation.reference}}</div>
                                                }
                                                @if (reservation.main_guest) {
                                                    <div class="tw-truncate">{{reservation.main_guest.name}} {{reservation.main_guest.surname}}</div>
                                                }
                                                <div>{{parseLeanDate(reservation.date_from)}} - {{parseLeanDate(reservation.date_to)}}</div>
                                            </div>
                                            <div class="tw-font-bold tw-text-3xl tw-flex tw-flex-row tw-items-center tw-flex-shrink-0">
                                                @if ( !hideRoomPrefix && !isMobile() ) {
                                                    <span class="tw-mr-2 tw-truncate">{{reservation.room_type}}</span>
                                                }
                                                <span>{{reservation.room}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </mat-list-option>
                                <mat-divider />
                            }
                        </mat-selection-list>
                    }
                </div>
            }
            @case ('login') {
                <div class="tw-flex tw-flex-col">
                    <span class="tw-whitespace-pre tw-text-center" translate>CASHREGISTER.LEAN_PMS_PAYMENTS.PAIR_NECESSARY</span>

                    <form class="tw-flex tw-flex-col tw-mt-16">
                        <mat-form-field>
                            <mat-label translate>CASHREGISTER.LEAN_PMS_PAYMENTS.HOSTNAME</mat-label>
                            <input matInput type="text" [(ngModel)]="hostname" [ngModelOptions]="{standalone: true}" required aria-label="LeanPMS hostname" />
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label translate>CASHREGISTER.LEAN_PMS_PAYMENTS.USERNAME</mat-label>
                            <input matInput type="text" [(ngModel)]="username" [ngModelOptions]="{standalone: true}" required aria-label="LeanPMS username" />
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label translate>CASHREGISTER.LEAN_PMS_PAYMENTS.PASSWORD</mat-label>
                            <input matInput type="text" [(ngModel)]="password" [ngModelOptions]="{standalone: true}" required aria-label="LeanPMS password" />
                        </mat-form-field>

                        <button mat-raised-button color="primary" (click)="login()">{{'CASHREGISTER.LEAN_PMS_PAYMENTS.PAIR' | translate}}</button>
                    </form>
                </div>
            }
            @case ('hotel-select') {
                <div class="tw-flex tw-flex-col">
                    <span class="tw-whitespace-pre tw-text-center" translate>CASHREGISTER.LEAN_PMS_PAYMENTS.PAIR_NECESSARY</span>

                    <form class="tw-flex tw-flex-col tw-mt-16">
                        <mat-form-field class="tw-flex">
                            <mat-label translate>CASHREGISTER.LEAN_PMS_PAYMENTS.HOTEL</mat-label>
                            <mat-select [(ngModel)]="hotelId" [ngModelOptions]="{standalone: true}" required>
                                @for ( hotel of hotels; track hotel.id ) {
                                    <mat-option [value]="hotel.id">{{hotel.name}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>

                        <button mat-raised-button color="primary" (click)="pairHotel()">{{'CASHREGISTER.LEAN_PMS_PAYMENTS.PAIR' | translate}}</button>
                    </form>
                </div>
            }
            @case ('groupedreservations-select') {
                <div class="tw-flex tw-flex-col tw-mb-4 tw-overflow-auto">
                    @if ( !visibleGroupReservations.length && !operationInProgress && !message ) {
                        <div class="tw-text-blue-500 tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-[100px]">
                            <span translate>CASHREGISTER.LEAN_PMS_PAYMENTS.NO_GROUPED_RESERVATIONS</span>
                        </div>
                    } @else {
                        <mat-selection-list class="tw-overflow-y-auto" [multiple]="false" (selectionChange)="onSelectionChange($event)">
                            @for ( reservation of visibleGroupReservations; track reservation.id) {
                                <mat-list-option [value]="reservation" class="tw-h-fit" [selected]="reservation === selectedReservation">
                                    <div class="tw-flex tw-flex-row tw-w-full">
                                        <mat-icon class="tw-mr-2" matListItemIcon>meeting_room</mat-icon>
                                        <div class="tw-flex tw-flex-row tw-w-full tw-justify-between tw-min-w-0">
                                            <div class="tw-flex tw-flex-col tw-flex-1 tw-min-w-0 tw-overflow-hidden">
                                                <div class="tw-truncate">{{reservation.name}}</div>
                                                <div class="tw-truncate">{{reservation.contact_name}}</div>
                                            </div>
                                            <div class="tw-font-bold tw-text-3xl tw-flex tw-flex-row tw-items-center tw-flex-shrink-0">
                                                <span>{{reservation.id}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </mat-list-option>
                                <mat-divider />
                            }
                        </mat-selection-list>
                    }
                </div>
            }
        }

        @if ( mode === 'services-view' && selectedReservation ) {
            <div class="tw-flex" [ngClass]="isMobile() ? ['tw-flex-col', 'tw-gap-3', 'tw-h-2/5' ] : ['tw-flex-row', 'tw-gap-1','tw-h-[100px]']">
                <div class="lean-pms-room-service-container tw-flex tw-flex-col" [ngClass]="isMobile() ? ['tw-w-full', 'tw-h-1/2'] : 'tw-w-1/2'">
                    <span class="lean-pms-room-service-header" translate>CASHREGISTER.PMS_COMMON.ROOM_SERVICES_INCLUDED</span>
                    <div class="tw-flex tw-flex-col tw-overflow-auto">
                        @for (service of selectedReservationExtras; track service.extra_id; let i = $index) {
                            <span class="tw-font-bold tw-text-[12px] tw-pl-1" [ngClass]="{ 'tw-bg-gray-200': (i + 1) % 2 === 0 }">{{service.board_type}} - {{service.name}}</span>
                        } @empty {
                            <span class="tw-font-bold tw-text-[12px] tw-pl-1" translate>CASHREGISTER.PMS_COMMON.NO_SERVICES</span>
                        }
                    </div>
                </div>

                <div class="lean-pms-room-service-container tw-flex tw-flex-col" [ngClass]="isMobile() ? ['tw-w-full', 'tw-h-1/2'] : 'tw-w-1/2'">
                    <span class="lean-pms-room-service-header" translate>CASHREGISTER.PMS_COMMON.ROOM_NOTE</span>
                    <div class="tw-flex tw-flex-col" [ngClass]="notesInProgress ? ['tw-m-auto'] : ['tw-overflow-auto']">
                        @if ( notesInProgress ) {
                            <div class="tw-flex tw-flex-row tw-justify-center">
                                <mat-spinner [diameter]="50" />
                            </div>
                        } @else {
                            @for (note of selectedReservationNotes; track note.id; let i = $index ) {
                                <span class="tw-font-bold tw-text-[12px] tw-pl-1" [ngClass]="{ 'tw-bg-gray-200': (i + 1) % 2 === 0 }">{{note.content}}</span>
                            } @empty {
                                <span class="tw-font-bold tw-text-[12px] tw-pl-1" translate>CASHREGISTER.PMS_COMMON.NO_NOTES</span>
                            }
                        }
                    </div>
                </div>
            </div>
        }
    }
</tilby-dialog-content>
